import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

export function MobileBar() {
  const location = useLocation();
  const [financeOpen, setFinanceOpen] = useState(false);

  useEffect(() => {
    const onFinance = (e) => setFinanceOpen(!!e.detail?.open);
    window.addEventListener("swapa:finance", onFinance);
    return () => window.removeEventListener("swapa:finance", onFinance);
  }, []);

  if (financeOpen) return null;
  if (location.pathname.startsWith("/admin") || location.pathname.startsWith("/preordina") || location.pathname.startsWith("/pagamento") || location.pathname.startsWith("/hospitality")) {
    return null;
  }
  const isGuide = location.pathname.startsWith("/guide");
  return (
    <div
      data-testid="mobile-conversion-bar"
      className="fixed inset-x-0 bottom-0 z-40 flex items-stretch border-t border-white/10 bg-black/85 backdrop-blur-xl sm:hidden"
    >
      <div className="flex flex-1 flex-col justify-center px-4 py-2.5">
        <span className="font-display text-base font-bold leading-none">€13.990</span>
        <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-zinc-500">IVA inclusa</span>
      </div>
      {isGuide ? (
        <Link
          to="/test-drive"
          data-testid="mobile-bar-testdrive"
          className="flex items-center bg-swapa-yellow px-6 font-mono text-[11px] font-semibold uppercase tracking-[0.15em] text-black"
        >
          Prenota test drive
        </Link>
      ) : (
        <Link
          to="/preordina"
          data-testid="mobile-bar-preorder"
          className="flex items-center bg-swapa-yellow px-6 font-mono text-[11px] font-semibold uppercase tracking-[0.15em] text-black"
        >
          Pre-ordina — €200
        </Link>
      )}
    </div>
  );
}
